import React, { FC } from "react";

import DocsButton from "./docs";
import SigninButton from "./signin";
import BookADemoButton from "./book-a-demo";
import { UtmParameters } from "@src/helpers/utms";

interface Props {
  type: string;
  label?: string;
  size?: "normal" | "large";
  variant?: "contained" | "outlined";
  ctaUtms?: UtmParameters;
}

const ButtonPicker: FC<Props> = ({
  type,
  label,
  size = "normal",
  variant = "outlined",
  ctaUtms = {},
}) => {
  if (type === "docs") {
    return <DocsButton label={label} />;
  }

  if (type === "book-a-demo") {
    return <BookADemoButton label={label} ctaUtms={ctaUtms} />;
  }

  if (type === "signin") {
    const sxProps =
      size === "large"
        ? {
            height: "50px",
            fontSize: "16px",
            lineHeight: "31px",
            fontWeight: "400",
            borderRadius: "8px",
          }
        : {};

    return (
      <SigninButton
        label={label}
        color="primary"
        buttonSx={sxProps}
        variant={variant}
        ctaUtms={ctaUtms}
      />
    );
  }

  return <></>;
};

export default ButtonPicker;
